export default [
  {
    position: "absolute",
    top: 12,
    left: 48.2,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "actions.persona1.mTitleOne",
    mBody: "actions.persona1.mBodyOne",
    isVideo: true,
    videoThumb: "OB-Actions-Thumb",
    videoURL: "OB-Actions-List.mp4",
    vidIcon: true,
    id: "OB_Actions_Video_TrackActions",
    index: 0,
  },
  {
    position: "absolute",
    top: 2.7,
    left: 5.6,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "actions.persona1.ttTextOne",
    hover: false,
    id: "OB_Actions_Navigation_Homepage",
    index: 1,
  },
  {
    position: "absolute",
    top: 1.9,
    left: 32.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "actions.persona1.ttTextTwo",
    hover: false,
    id: "OB_Actions_Navigation_PersonalDetails",
    index: 2,
  },
  {
    position: "absolute",
    top: 1.9,
    left: 60.6,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 4,
    tooltipText: "actions.persona1.ttTextThree",
    hover: false,
    id: "OB_Actions_Navigation_Policies",
    index: 3,
  },
  {
    position: "absolute",
    top: 1.9,
    left: 69.6,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 5,
    tooltipText: "actions.persona1.ttTextFour",
    hover: false,
    id: "OB_Actions_Navigation_Feedback",
    index: 4,
  },
];
